// WARN: Internal re-export, don't rely on this to be a public API
module.exports = require('../src/async-require/asyncRequireModule');
